import React, { useMemo } from 'react';
import { List } from '@material-ui/core';
import { sortBy } from 'lodash';
import { TagDefinition } from '../../../../models';
import { TagListItem } from './TagListItem';

const MemoList = React.memo(List);

export interface TagListProps {
  tags: TagDefinition[];
  selectedTags?: string[];
  onToggle?: (tagId: string) => void;
  disabled?: (tag: TagDefinition) => boolean;
  showCheckbox?: boolean;
}

export const TagList: React.FC<TagListProps> = ({
  tags,
  selectedTags = [],
  onToggle,
  disabled,
  showCheckbox = true,
}) => {
  const sortedTags = useMemo(() => sortBy(tags, (tag) => tag.label || tag.id), [tags]);

  return (
    <MemoList disablePadding dense>
      {sortedTags.map((tag) => {
        const isDisabled = disabled ? disabled(tag) : false;
        return (
          <TagListItem
            key={tag.id}
            tag={tag}
            onToggle={onToggle}
            isSelected={selectedTags.includes(tag.id)}
            disabled={isDisabled}
            showCheckbox={showCheckbox}
          />
        );
      })}
    </MemoList>
  );
};
